import IFrame from "../IFrame";
import * as domHelpers from "../../scripts/utils/domHelpers.js";

class SupplementaryEventsPage {
    constructor() {
        this.moveInfoMessage();
        this.wrapHeader();
        this.restructureEventDivs();
        this.removeEventDate();
    }

    wrapHeader() {
        const headerElement = document.getElementById(
            "ctl00_ContentPlaceHolder_SupplementaryEventsWikiTextViewer",
        );

        if (!headerElement) {
            return;
        }

        domHelpers.wrapAll(headerElement.parentNode, {
            element: "div",
            className: "spektrix-page-header",
        });

        // get child nodes that aren't html elements and wrap them in a p tag
        const nonElementChildren = Array.from(headerElement.childNodes).filter(
            (child) => child.nodeType === Node.TEXT_NODE,
        );

        domHelpers.wrapEach(nonElementChildren, {
            element: "p",
        });
    }

    clearBrSpans() {
        const spanBr = document.querySelectorAll(
            ".SupplementaryEventDiv span br:only-child",
        );

        spanBr.forEach((spanBr) => {
            spanBr.parentNode.remove();
        });
    }

    removeEventDate() {
        const eventDates = document.querySelectorAll(".Event_Dates");

        eventDates.forEach((eventDate) => {
            eventDate.remove();
        });
    }

    // Restructure the SupplementaryEventDivs markup so that elements are in the right order and
    // wrapped appropriately.
    // This function isn't very readable and could possibly be improved using an html template approach.
    restructureEventDivs() {
        const eventDivs = document.querySelectorAll(".SupplementaryEventDiv");

        this.clearBrSpans();

        eventDivs.forEach((eventDiv) => {
            const newEventDiv = eventDiv.cloneNode(true);

            const ticketTypes = newEventDiv.querySelectorAll(".TicketType");
            const eventText = newEventDiv.querySelector(".Event_Text");
            const imgElements = eventText.querySelectorAll("img");
            const seatingDivs =
                newEventDiv.querySelectorAll("#SimpleSeatingDiv");

            // Add .SimpleSeatingDiv to #SimpleSeatingDiv
            if (seatingDivs.length > 0) {
                seatingDivs.forEach((seatingDiv) => {
                    seatingDiv.classList.add("SimpleSeatingDiv");
                });
            }

            // If there are images in the event text, move them out to a new container
            if (imgElements.length > 0) {
                const eventMedia = document.createElement("div");

                eventMedia.classList.add("Event_Media");
                eventMedia.setAttribute("data-custom-element", "");

                imgElements.forEach((img) => {
                    eventMedia.appendChild(img);
                });

                newEventDiv.insertBefore(eventMedia, eventText);
            }

            // Create a new wrapper for event title, content and input elements
            const eventContent = document.createElement("div");
            eventContent.classList.add("Event_Content");

            eventContent.appendChild(eventText);

            newEventDiv.appendChild(eventContent);

            // If there's only one ticket type (e.g. one set of inputs), move the title and price above the description.
            if (ticketTypes.length === 1) {
                const ticketType = ticketTypes[0];

                // Move Text Elements from TicketType to Event_Header
                const textElements = ticketType.querySelectorAll("span");

                const eventHeader = document.createElement("div");
                eventHeader.classList.add("Event_Header");

                textElements.forEach((textElement) => {
                    eventHeader.appendChild(textElement);
                });

                eventContent.insertBefore(eventHeader, eventText);

                // Move input Elements from TicketType to Event_Footer
                const inputElements = ticketType.querySelectorAll(
                    ":scope > input, quantity-input",
                );

                const eventFooter = document.createElement("div");
                eventFooter.classList.add("Event_Footer");

                inputElements.forEach((textElement) => {
                    eventFooter.appendChild(textElement);
                });

                eventContent.appendChild(eventFooter);

                // Remove the #SimpleSeatingDiv as we've emptied it.
                seatingDivs[0].remove();
            }

            // Modifications complete - add data-customised attribute to new element
            // as an indicator that the element has been modified
            newEventDiv.setAttribute("data-customised", "true");

            eventDiv.replaceWith(newEventDiv);
        });
    }

    // Move the InfoMessage which displays when an item is added to the basket to the top of the page
    moveInfoMessage() {
        const supplementaryEventDivs = document.querySelectorAll(
            ".SupplementaryEventDiv",
        );

        const infoMessage = document.querySelector(".InfoMessage");

        if (supplementaryEventDivs.length > 0 && infoMessage) {
            const firstSupplementaryEventDiv = supplementaryEventDivs[0];

            firstSupplementaryEventDiv.parentNode.insertBefore(
                infoMessage,
                firstSupplementaryEventDiv,
            );
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(
        ".SpektrixPage.SupplementaryEventsPage",
    );

    if (pageSelector) {
        new SupplementaryEventsPage();
    }
});
